import React from 'react';
import MediaQuery from 'react-responsive';
import BasicButton from 'components/BasicButton';
import BasicControlGroup from 'components/BasicControlGroup';
import LinkButton from 'components/LinkButton';
import './styles.css';

const BasicSection = props => {
  const { title, controls = [], buttons = [], renderHeaderBlock } = props;

  const buttonControls = (
    <div className="basic-section__buttons">
      <BasicControlGroup>
        {buttons.map((button, index) => {
          return (
            <BasicButton
              key={index}
              btnWidth={200}
              btnHeight={40}
              btnFontSize="0.8571rem"
              btnFontWeight={600}
              btnText={button.caption}
              btnArrow={false}
              btnBg="#fff"
              btnHoverBg="#f40"
              controlFunc={button.handler}
            />
          );
        })}
      </BasicControlGroup>
    </div>
  );

  const linkControls = (
    <BasicControlGroup>
      {controls.map((control, index) => {
        return (
          <LinkButton
            key={index}
            text={control.caption}
            controlFunc={control.handler}
          />
        );
      })}
    </BasicControlGroup>
  );

  return (
    <section className="basic-section">
      <div className="basic-section__header">
        <h3 className="basic-section__title">{title}</h3>
        <div className="basic-section__controls">
          {buttons && buttonControls}
          <MediaQuery query="(min-width: 768px)">
            {controls && linkControls}
          </MediaQuery>
        </div>
        {renderHeaderBlock && (
          <div className="basic-section__header-block">{renderHeaderBlock}</div>
        )}
      </div>

      <div className="basic-section__content">{props.children}</div>
      <MediaQuery query="(max-width: 767px)">
        <div className="basic-section__controls">
          {controls && linkControls}
        </div>
      </MediaQuery>
    </section>
  );
};

export default BasicSection;
